import { TruncateUrlPipe } from './truncate-url.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './truncate/truncate.pipe';
import { KeysPipe } from './keys/keys.pipe';
import { CounterPipe } from './counter/counter.pipe';
import { MakeLinkPipe, RemoveEndSpacesPipe } from '../../pages/details/details.component';
import { ReplaceLineBreaksPipe } from './replace-line-breaks/replace-line-breaks.pipe';
import { SantizeValuePipe } from './sanitze-value/santize-value.pipe';
import { NormalizeUrl, SafeUrlPipe } from './safe-url.pipe';
import { DecodeHtmlStringPipe } from '../../components/search/verso-holdings/verso-holdings.component';
import { AddStyleToHtmlPipe } from '../../components/search/advanced-resources/advanced-resources.component';
import { RemoveWhiteSpacesPipe } from './remove-white-spaces/remove-white-spaces.pipe';
import { ModifyPhoneNumberPipe } from './modify-phone-number/modify-phone-number.pipe';
import { ReplaceUserGuidesStringsQuickLinksPipe } from './replace-user-guides-strings-quick-links/quick-links-user-guides.pipe';
import { HighlightsSearchTermPipe, EncapsulateSpanPipe } from './highlights/highlights.pipe';
import { HightlightPipe } from './highlight-pipe/hightlight.pipe';
import {
  ViewRecordPipe,
  ViewRecordQueryParamsPipe,
  DetailsQueryParamsPipe,
  HasFacetIndexPipe as FacetHasIndexPipe,
} from '../../pages/search/search.component';
import {
  CellConvertArrayPipe,
  CellDisplayFunctionPipe,
} from '../../components/table/table-grid/table-grid.component';
import { ReplacePipe } from './replace.pipe';
import { VisualizeSpacesPipe } from './visualize-spaces.pipe';
import { SafeHtmlPipe } from './safeHtml/safe-html.pipe';
import { SortDocFormatPipe } from './sort-doc-format/sort-doc-format.pipe';
import { ShortNumberStringPipe } from './short-number-string.pipe';
import { DateParsePipe } from './date-parse/date-parse.pipe';
import {
  FulfillmentLabelPipe,
  FulfillmentTypePipe,
  ShowFulfillmentActionPipe,
} from '../../services/fulfillment.service';
import { HoldingStatusPipe } from '../../pages/holdings/holding-form/holding-form.component';
import { IncludesPipe } from './includes.pipe';
import { SortPipe } from './sort.pipe';
import { HomeLocationDisplayPipe } from './location.pipe';
import { ErrorMessagePipe } from '../../components/dynamic-form/error-message.pipe';
import { TrimLowerPipe } from './trim-lower.pipe';
import { PluralPipe } from './plural.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    // Pipes
    TruncatePipe,
    KeysPipe,
    CounterPipe,
    MakeLinkPipe,
    ReplaceLineBreaksPipe,
    HightlightPipe,
    HighlightsSearchTermPipe,
    EncapsulateSpanPipe,
    SantizeValuePipe,
    DecodeHtmlStringPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    NormalizeUrl,
    RemoveEndSpacesPipe,
    AddStyleToHtmlPipe,
    RemoveWhiteSpacesPipe,
    ModifyPhoneNumberPipe,
    ReplaceUserGuidesStringsQuickLinksPipe,
    ReplacePipe,
    ShowFulfillmentActionPipe,
    FulfillmentLabelPipe,
    FulfillmentTypePipe,
    ShortNumberStringPipe,
    ViewRecordPipe,
    ViewRecordQueryParamsPipe,
    DetailsQueryParamsPipe,
    CellConvertArrayPipe,
    CellDisplayFunctionPipe,
    VisualizeSpacesPipe,
    SortDocFormatPipe,
    FacetHasIndexPipe,
    DateParsePipe,
    TruncateUrlPipe,
    HoldingStatusPipe,
    IncludesPipe,
    SortPipe,
    HomeLocationDisplayPipe,
    ErrorMessagePipe,
    TrimLowerPipe,
    PluralPipe,
  ],

  exports: [
    TruncatePipe,
    KeysPipe,
    CounterPipe,
    MakeLinkPipe,
    ReplaceLineBreaksPipe,
    HightlightPipe,
    HighlightsSearchTermPipe,
    EncapsulateSpanPipe,
    SantizeValuePipe,
    DecodeHtmlStringPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    NormalizeUrl,
    RemoveEndSpacesPipe,
    AddStyleToHtmlPipe,
    RemoveWhiteSpacesPipe,
    ModifyPhoneNumberPipe,
    ReplaceUserGuidesStringsQuickLinksPipe,
    ReplacePipe,
    ShortNumberStringPipe,
    ShowFulfillmentActionPipe,
    FulfillmentLabelPipe,
    FulfillmentTypePipe,
    ViewRecordPipe,
    ViewRecordQueryParamsPipe,
    DetailsQueryParamsPipe,
    CellConvertArrayPipe,
    CellDisplayFunctionPipe,
    VisualizeSpacesPipe,
    SortDocFormatPipe,
    FacetHasIndexPipe,
    DateParsePipe,
    TruncateUrlPipe,
    HoldingStatusPipe,
    IncludesPipe,
    SortPipe,
    HomeLocationDisplayPipe,
    ErrorMessagePipe,
    TrimLowerPipe,
    PluralPipe,
  ],
})
export class PipesSharedModule {}
